import { render, staticRenderFns } from "./rockGame.vue?vue&type=template&id=407f5fca"
import script from "./rockGame.vue?vue&type=script&lang=js"
export * from "./rockGame.vue?vue&type=script&lang=js"
import style0 from "./rockGame.vue?vue&type=style&index=0&id=407f5fca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports